import React, { Component } from 'react';
import { T } from '../../../../../common/locale/translate';
import { numeralTranslation } from '../../../services/services';

export default class ReviewsTab extends Component {
  constructor(props) {
    super(props);
    this.state = {
      allowed_keys: [
        'price_quality',
        'location',
        'service',
        'board',
        'accommodation',
        'attractions'
      ]
    };
  }

  render() {
    return (
      <div className="hotel-reviews">
        {this.props.subject.giata_id
          ? this.renderTrustYouReviews()
          : Object.keys(this.props.subject.review).length
            ? this.renderZooverReviews()
            : ''}
      </div>
    );
  }

  static hasTrustYouReview(subject) {
    return (
      subject.giata_id &&
      subject.review &&
      Object.keys(subject.review).length &&
      subject.review.overall
    );
  }

  static hasZooverReviews(subject) {
    return (
      !subject.giata_id && subject.review && Object.keys(subject.review).length
    );
  }

  renderZooverReviews() {
    const reviews = this.props.subject.review;
    return (
      <div className="zoover">
        <div className="overall-rating-wrapper">
          <div className="overall-inner-wrapper">
            <div
              className={`rating-number zoover-${Math.ceil(
                parseFloat(reviews['overall'])
              )}`}
            >
              <span className="value">
                <em>{reviews['overall']}</em> / 10
              </span>
            </div>
            <span className="zoover-rating zoover-rating-10" />
            <span className="review-number">
              {reviews['total_reviews']}{' '}
              {numeralTranslation(parseInt(reviews['total_reviews']), [
                T('review1'),
                T('review2'),
                T('review3')
              ])}
            </span>
          </div>
        </div>
        <div className="particulars-rating-wrapper">
          {this.state.allowed_keys.map(key => {
            if (typeof reviews[key] !== 'undefined') {
              return (
                <div className="particular-review">
                  <div className="name-wrapper">
                    <span className="name">{T(key)}</span>
                  </div>
                  <div className="rating-wrapper">
                    <span
                      className={`zoover-rating zoover-rating-${Math.ceil(
                        parseFloat(reviews[key])
                      )}`}
                    />
                  </div>
                  <div className="number-wrapper">
                    <span className="number">
                      {parseFloat(reviews[key]).toFixed(1)}
                    </span>
                  </div>
                </div>
              );
            }
          })}
        </div>
        <div className="zoover-logo-wrapper">
          <div className="logo">
            <span className="provider-name">{T('reviews_provider')}</span>
            <div className="img-wrapper">
              <a href="http://www.zoover.pl" target="_blank">
                <img src="/img/zoover.svg" alt="" />
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderTrustYouReviews = () => (
    <div className="trustyou">
      <iframe
        title="zoover-opinions"
        src={`https://api.trustyou.com/hotels/mappings/giata/${
          this.props.subject.giata_id
        }/tops_flops.html?lang=${this.props.lang}`}
      />
    </div>
  );
}



// WEBPACK FOOTER //
// ./app/javascript/pages/offer/components/reviews_tab.jsx